import { render, staticRenderFns } from "./IzvestajSipanjaGoriva.vue?vue&type=template&id=42e7d519&scoped=true&"
import script from "./IzvestajSipanjaGoriva.vue?vue&type=script&lang=ts&"
export * from "./IzvestajSipanjaGoriva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e7d519",
  null
  
)

export default component.exports